
import HomeHero from '../components/HomeHero'
import { Helmet, HelmetProvider } from 'react-helmet-async';
import InsideBrandAcumen from '../components/InsideBrandAcumen';
import ClientsSection from '../components/ClientsSection';
import ServicesSection from '../components/ServicesSection';
import InsightsSection from '../components/InsightsSection';
import AboutUsSection from '../components/AboutUsSection';
import FeaturedCaseStudy from '../components/FeaturedCaseStudy';
import TestimonialCarousel from '../components/TestimonialSlider'

const Home = () => {
  return (
    <>
      <HelmetProvider>
      <Helmet>
        <title>Home | Brand Acumen</title>
        <meta name="description" content="Welcome to the homepage of Brand Acumen." />
        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Home | Brand Acumen" />
        <meta property="og:description" content="Welcome to the homepage of Brand Acumen." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://brandacumen.co/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Home | Brand Acumen" />
        <meta name="twitter:description" content="Welcome to the homepage of Brand Acumen." />
        <meta name="twitter:image" content="/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>

      <HomeHero />
      <ClientsSection />
      <TestimonialCarousel />
      <InsideBrandAcumen />
      <FeaturedCaseStudy />
      <ServicesSection />
      <InsightsSection />
      <AboutUsSection />
      </HelmetProvider>
    </>
  );
};

export default Home;
